<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (tap)="modalController.dismiss()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-searchbar placeholder="Search Serial" debounce="300" [(ngModel)]="queryText"></ion-searchbar>
        <ion-buttons slot="end">
            <ion-button (tap)="checkOutSerials()" shape="round">
                <ion-icon slot="icon-only" name="checkmark" color="success"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list>
        <ion-item *ngFor="let item of ptSerialsDisplay | filterSerial: queryText">
            <ion-label>{{item.serial.serialNo}}</ion-label>
            <ion-checkbox color="success" [(ngModel)]="item.isChecked" (ionChange)="countChecked()"></ion-checkbox>
        </ion-item>
    </ion-list>
</ion-content>
<ion-footer>
    <ion-label class="ion-text-center" [color]="count !== product.qty ? 'danger' : 'success'">
        <p>Selected: {{count}} of {{product.qty}}</p>
    </ion-label>
</ion-footer>
